import { IconWarning } from '../../../assets/DesignSystem/SVGComponents';
import BordOneToneIcon from '../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import './EmptyReportLogisticServiceProblem.scss';

const EmptyReportLogisticServiceProblem = () => {
  return (
    <div className="emptyReportLogisticServiceProblem">
      <div className="title">
        Reportar un problema en el servicio
        <IconWarning className="IconWarning" />
      </div>

      <div className="descriptionContainer">
        <div className="descriptionIconContainer">
          <BordOneToneIcon variant="layers" standardSize={52} />
        </div>
        <div className="description">Disponible cuando el servicio esté confirmado</div>
      </div>
    </div>
  );
};

export default EmptyReportLogisticServiceProblem;
